/**
 * Haptics — short physical pulses on supported devices so mobile play
 * has tactile feedback for the moments that matter. Calls
 * `navigator.vibrate` and gracefully no-ops where unsupported (most
 * desktop browsers, iOS Safari < 16.4 without explicit permission,
 * etc.).
 *
 * Patterns are intentionally short and discrete — long pulses feel
 * intrusive in a 60 fps action game and drain battery. The numbers
 * below are tuned to the mobile-game category:
 *
 *   - tap:        6 ms   — button press confirmation
 *   - eat:        4 ms   — pellet pickup (unused: too dense, spammy)
 *   - kill:       30 ms  — landed a kill on a rival
 *   - milestone:  20 ms  — crossed a mass threshold
 *   - death:      [60, 40, 80]  — felt-bad bzzz pattern
 *   - reward:     [10, 30, 10]  — light celebratory pulse
 *
 * Calls are wrapped in try/catch because some browsers throw on the
 * pattern overload, and we'd rather silently drop a pulse than crash
 * the game.
 */
export function buzz(pattern: number | number[]): void {
  try { (navigator as Navigator & { vibrate?: (p: number | number[]) => boolean }).vibrate?.(pattern); } catch { /* unsupported */ }
}

export const HAPTIC: {
  tap: number;
  kill: number;
  milestone: number;
  death: number[];
  reward: number[];
} = {
  tap: 6,
  kill: 30,
  milestone: 20,
  death: [60, 40, 80],
  reward: [10, 30, 10],
};
